import {
  GlobalContext,
  TimelineContext,
  ContextoReset,
  TranslationProvider,
} from "../helpers/Context";
import { TimelineDefault } from "../helpers/Constants";
import React, { useState } from "react";

const GlobalDefault = {
  startCase: null,
  userData: null,
  isLogin: true,
};

export const AppProvider = ({ children }) => {
  const [contextGolbal, setContextGolbal] = useState(GlobalDefault);
  const [contextTimeline, setContextTimeline] = useState(TimelineDefault);
  const ContextoDefault = {
    resetTimeline: () => setContextTimeline(TimelineDefault),
  };

  // Protección para evitar errores si TimelineDefault no está definido
  const safeTimeline = contextTimeline || TimelineDefault;
  const safeGlobal = contextGolbal || GlobalDefault;

  return (
    <TranslationProvider>
      <GlobalContext.Provider value={{ ...safeGlobal }}>
        <TimelineContext.Provider value={{ ...safeTimeline }}>
          <ContextoReset.Provider value={ContextoDefault}>
            {children}
          </ContextoReset.Provider>
        </TimelineContext.Provider>
      </GlobalContext.Provider>
    </TranslationProvider>
  );
};
